'use client';

const FretboardDisplaySettings = ({
  dispatch,
  boxModeEnabled,
  mode,
  currentSystem,
  availableBoxes,
  box,
  stylePresets,
  isInitialized
}) => {
  const isPentatonic = mode.includes('pentatonic');

  const handleSystemChange = (newSystem) => {
    dispatch({ type: 'SET_SYSTEM', payload: newSystem });
  };

  const handleBoxChange = (newBox) => {
    dispatch({ type: 'SET_BOX', payload: newBox });
  };

  const handleBoxModeToggle = (enabled) => {
    dispatch({ type: 'SET_BOX_MODE', payload: enabled });
  };

  return (
    <section className="space-y-4">
      {/* Display Mode Toggle */}
      {isInitialized && (
        <fieldset className="fieldset border border-base-300 bg-base-100 p-4 rounded-box">
          <legend className="fieldset-legend">Display Mode</legend>
          <div className="flex justify-between items-center">
            <div className="join">
              <button
                type="button"
                className={`btn btn-secondary join-item ${boxModeEnabled ? 'btn-outline' : 'btn-active'}`}
                onClick={() => handleBoxModeToggle(false)}
              >
                Full Scale
              </button>
              <button
                type="button"
                className={`btn btn-secondary join-item ${boxModeEnabled ? 'btn-active' : 'btn-outline'}`}
                onClick={() => handleBoxModeToggle(true)}
              >
                Box System
              </button>
            </div>
          </div>
        </fieldset>
      )}

      {/* Full Mode Settings */}
      {!boxModeEnabled && isInitialized && (
        <fieldset className="fieldset border border-base-300 bg-base-100 p-4 rounded-box">
          <legend className="fieldset-legend">Display Settings</legend>
          <div className="join flex-wrap">
            <button type="button" className="btn join-item" onClick={stylePresets.showNotes}>Note Names</button>
            <button type="button" className="btn join-item" onClick={stylePresets.showNotesWithOctave}>Note + Octave</button>
            <button type="button" className="btn join-item" onClick={stylePresets.showAllIntervals}>Intervals</button>
            <button type="button" className="btn join-item" onClick={stylePresets.highlightRoot}>Highlight Root</button>
            <button type="button" className="btn join-item" onClick={stylePresets.highlightRootTriad}>Root Triad</button>
            <button type="button" className="btn join-item" onClick={stylePresets.reset}>Clear</button>
          </div>
        </fieldset>
      )}

      {/* Box Mode Settings */}
      {boxModeEnabled && isInitialized && (
        <fieldset className="fieldset flex gap-2 border border-base-300 bg-base-100 p-4 rounded-box space-y-4">
          <legend className="fieldset-legend">Box Mode Settings</legend>
          <div>
            {/* System Toggle (non-pentatonic only) */}
            {!isPentatonic && (
              <div>
                <h3 className='text-md font-bold text-base-content/70 ml-2 mb-2'>Box System</h3>
                <div className="join">
                  <button
                    type="button"
                    className={`btn btn-outline btn-accent join-item ${currentSystem === 'CAGED' ? 'btn-active' : ''}`}
                    onClick={() => handleSystemChange('CAGED')}
                  >
                CAGED
                  </button>
                  <button
                    type="button"
                    className={`btn btn-outline btn-accent join-item ${currentSystem === 'TNPS' ? 'btn-active' : ''}`}
                    onClick={() => handleSystemChange('TNPS')}
                  >
                3NPS
                  </button>
                </div>
              </div>
            )}
          </div>

          <div>
            <h3 className='text-md font-bold text-base-content/70 ml-2 mb-2'>Box Selection</h3>
            {/* Box Selection */}
            {availableBoxes.length > 0 && (
              <div className="join">
                {availableBoxes.map((boxValue) => {
                  let labelText = boxValue;
                  let tooltipText = '';

                  if (currentSystem === 'TNPS') {
                    labelText = `Pattern ${boxValue}`;
                    tooltipText = `Three Note Per String Pattern ${boxValue}`;
                  } else if (currentSystem === 'CAGED') {
                    labelText = `${boxValue} Shape`;
                    tooltipText = `CAGED Pattern based on ${boxValue} chord`;
                  } else {
                    labelText = `Box ${boxValue}`;
                    tooltipText = `Pentatonic Box ${boxValue}`;
                  }

                  return (
                    <label key={boxValue} className="label tooltip" data-tip={tooltipText}>
                      <input
                        type="radio"
                        name="box-selection"
                        className="join-item btn"
                        value={boxValue}
                        checked={String(box) === String(boxValue)}
                        onChange={(e) => handleBoxChange(e.target.value)}
                        aria-label={labelText}
                      />
                    </label>
                  );
                })}
              </div>
            )}
          </div>
        </fieldset>
      )}
    </section>
  );
};

export default FretboardDisplaySettings;
